//@ts-ignore
export const hooks = String(new URL('./hooks.mjs', import.meta.url))
